// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ObdJG","colBig":"styles_colBig__1pLpf","colSmall":"styles_colSmall__3bSNk"};